export default "__VITE_ASSET__Brq55DgL__"